export const VERSAO = "5.0";

/* MENUS LAYERS */
export const AERODROMOS = "Aeródromos";
export const SATELITE = "Satélite";
export const RADAR = "Radares";
export const SIGMET = "SIGMET";
export const TSC = "TSC";
